import { Box, Stack, Typography, useMediaQuery } from "@mui/material";

import { type Insight } from "../types";

const getCloudName = (tag: string): string => {
  switch (tag) {
    case "aws":
      return "AWS";
    case "gcp":
      return "GCP";
    case "azure":
      return "Azure";
    case "snowflake":
      return "Snowflake";
  }
  return "";
};

type InsightTagsListProps = {
  insight: Insight;
};

export const InsightTagsList: React.FC<InsightTagsListProps> = ({ insight }) => {
  const isMobile = useMediaQuery("(max-width:650px)");

  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      spacing={1}
      alignItems={isMobile ? "flex-start" : "center"}
      divider={
        isMobile ? null : (
          <Box sx={{ width: 2, height: 2, borderRadius: "50%", bgcolor: "text.secondary", alignSelf: "center" }} />
        )
      }
      sx={{ color: "text.secondary" }}
      height={isMobile ? "auto" : "28px"}
    >
      <Stack
        direction="row"
        spacing={1}
        divider={
          <Box sx={{ width: 2, height: 2, borderRadius: "50%", bgcolor: "text.secondary", alignSelf: "center" }} />
        }
      >
        {insight.cloudTags?.length > 0 && (
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Typography sx={{ fontSize: "12px" }} color="text.secondary" variant="body1">
              {insight.cloudTags?.map((tag) => getCloudName(tag)).join(", ")}
            </Typography>
          </Stack>
        )}
        {insight.categories?.length > 0 && (
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Typography sx={{ fontSize: "12px" }} color="text.secondary" variant="body1">
              {insight.categories?.join(", ")}
            </Typography>
          </Stack>
        )}
        {insight.tags?.length > 0 && (
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Typography sx={{ fontSize: "12px" }} color="text.secondary" variant="body1">
              Tags:{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                color: "text.secondary",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: isMobile ? "200px" : "250px",
              }}
              color="text.secondary"
              variant="body1"
            >
              {insight.tags?.join(", ")}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
